/**
 * AI assistant — transport helpers for the streaming chat endpoints.
 *
 * The chat is consumed by the AI SDK `useChat` hook over `fetch` (not Axios),
 * so the shared Axios interceptor does not apply. These pure helpers mirror it:
 * they build the absolute endpoint URL and the `Authorization` header from the
 * same token store.
 */

import { API_BASE_URL } from '@/api/config';
import { store } from '@/config/store.ts';
import { ASSISTANT_CHAT_PATH, EMAIL_BUILDER_CHAT_PATH } from './ai.types';

/** Absolute URL for the main EOS assistant chat stream endpoint. */
export const assistantChatUrl = (): string =>
  `${API_BASE_URL.replace(/\/+$/, '')}${ASSISTANT_CHAT_PATH}`;

/** Absolute URL for the email-builder chat stream endpoint. */
export const emailBuilderChatUrl = (): string =>
  `${API_BASE_URL.replace(/\/+$/, '')}${EMAIL_BUILDER_CHAT_PATH}`;

/**
 * Bearer `Authorization` header for the chat `fetch`, read from the same
 * Zustand token store the Axios request interceptor uses.
 */
export const aiAuthHeaders = (): Record<string, string> => {
  const token = store.tokenObject.value.auth?.token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};
